import { z } from 'zod';

import { getCombinationKey } from '../../utils';

const MIN_ITEM_SET_NEED_TOTAL = 1;

export const AddItemSetQuestionConditionsSchema = z.object({
  contentType: z.enum(['TOPIC', 'LOS']),
  itemSetType: z.preprocess(
    (val: unknown) => parseInt(val as string),
    z.number({ message: 'กรุณากรอกประเภท Item Set' }),
  ),
  location: z.object({
    topics: z.record(z.string().uuid(), z.boolean().nullish()),
    subtopics: z.record(z.string().uuid(), z.boolean().nullish()),
  }),
  los: z.array(
    z.object(
      {
        label: z.string(),
        value: z.string(),
        inputValue: z.string().nullish(),
      },
      {
        message: 'กรุณาเลือก LOS',
      },
    ),
  ),
  scorePerQuestion: z.number({
    message: 'กรุณากรอกคะแนนต่อข้อ',
  }),
  conditions: z
    .array(
      z
        .object({
          needTotal: z.number({ message: 'กรุณาระบุจำนวน Set' }).min(MIN_ITEM_SET_NEED_TOTAL, {
            message: `จำนวน Set ต้องมีอย่างน้อย ${MIN_ITEM_SET_NEED_TOTAL} Set`,
          }),
          properties: z.array(
            z.object({
              difficulty: z.object(
                {
                  label: z.string(),
                  value: z.string(),
                },
                {
                  message: 'กรุณาเลือกระดับความยาก',
                },
              ),
              calculated: z.object(
                {
                  label: z.string(),
                  value: z.string(),
                },
                {
                  message: 'กรุณาเลือกประเภทข้อสอบ',
                },
              ),
            }),
          ),
        })
        .nullable(),
    )
    .superRefine((conditions, ctx) => {
      const questionConditionsMap = new Map<string, number[]>();

      for (let questionIndex = 0; questionIndex < conditions.length; questionIndex++) {
        const condition = conditions[questionIndex];
        const combinationKey = getCombinationKey(condition?.properties ?? []);
        if (!questionConditionsMap.has(combinationKey)) {
          questionConditionsMap.set(combinationKey, []);
        }
        const questionConditions = questionConditionsMap.get(combinationKey);
        if (questionConditions) {
          questionConditions.push(questionIndex);
        }
      }

      for (const [, indices] of questionConditionsMap) {
        if (indices.length > 1) {
          const lastIndex = Math.max(...indices);

          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'กรุณาเลือกเงื่อนไขที่ไม่ซ้ำกับรายการอื่น',
            path: [lastIndex],
          });

          const condition = conditions[lastIndex];
          if (condition?.properties) {
            for (
              let conditionIndex = 0;
              conditionIndex < condition.properties.length;
              conditionIndex++
            ) {
              ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '',
                path: [lastIndex, 'properties', conditionIndex, 'difficulty'],
              });
              ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '',
                path: [lastIndex, 'properties', conditionIndex, 'calculated'],
              });
            }
          }
        }
      }
    }),
});

export type AddItemSetQuestionConditionsFormType = z.infer<
  typeof AddItemSetQuestionConditionsSchema
>;
